module.exports = __webpack_public_path__ + "630c98171127d128ec1fbb9b15e1458d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/notification.png
// module id = 479
// module chunks = 0